import React from "react";
import { useNavigate } from "react-router-dom";
import studentImg from "../assets/studentImg.svg";
import companyImg from "../assets/companyImg.svg";

const Register = () => {
  const navigate = useNavigate();

  const setStudentAsUser = () => {
    localStorage.setItem("userRole", "student");
    navigate("/signup");
  };
  const setCompanyAsUser = () => {
    localStorage.setItem("userRole", "organization");
    navigate("/signup");
  };
  return (
    <div className="flex xsm:flex-col items-center justify-center gap-3 text-green-600 h-screen font-bold text-2xl custom-bg">
      <section className="cursor-pointer w-[350px]" onClick={setStudentAsUser}>
        <img src={studentImg} alt="studentImg " className="w-full bg-white rounded-xl" />
      </section>
      <section className="cursor-pointer w-[350px]" onClick={setCompanyAsUser}>
        <img src={companyImg} alt="" className="w-full bg-white rounded-xl" />
      </section>
    </div>
  );
};

export default Register;
